export default function setGameType(payload) {
  return {
    type: "gameTypeChange",
    payload
  }
}